import { Link } from "react-router-dom";

function BillingCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-lg shadow-md p-8 text-center max-w-md w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">No charges were made.</p>
        <Link
          to="/company/flowsetting"
          state={{ activeTab: "Subscription" }}
          className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          Back to Pricing
        </Link>
      </div>
    </div>
  );
}

export default BillingCancel;
